import React, { Dispatch, useEffect, useMemo } from "react"
import { NewFieldStyles, NewFieldTypes, SystemTypes, ToggleStyles } from "../../../Definitions"
import { LocationInfo } from "../../../Services/Agrisys_GqlDataCaller/LocationFeedingCalls/GQLCalls/getLfStructureCall"
import { Station } from "../../../Services/Agrisys_GqlDataCaller/StationCalls/queryStations"
import { fonts, glyphs } from "../../../Styles"
import { NewInput, NewSelect, ToggleBox, TooltipString } from "../../BaseComponents"
import { IEsfContext } from "../../EsfWalkThrough/_EsfWalkThrough/EsfContext"
import { BaseIO } from "../../GlobalModals/editSectionModal"
import { ILfContext } from "../../LocationFeeder/_LocationFeeder/lfPenContext"
import { TerminalDataProps } from "../_GlobalComponents/editTerminalsData"
import { useTerminalResContext } from "../_GlobalComponents/terminalReducer"
import { useDeviceInfo } from "../../../Services"

export function getSelectedId<T extends SystemTypes>(systemType: T, selected: T extends SystemTypes.freedaEsf_WalkThrough ? Station : LocationInfo) {
  if (systemType === SystemTypes.freedaLf) return (selected as LocationInfo).location_id;
  if (systemType === SystemTypes.freedaEsf_WalkThrough) return (selected as Station).station_id;
  return NaN;
}

export type SystemProps<TSystem extends SystemTypes> = {
  systemType: TSystem
  selected: TSystem extends SystemTypes.freedaEsf_WalkThrough ? Station : LocationInfo
}

interface EditTerminalsRowProps<TSystem extends SystemTypes>
  extends SystemProps<TSystem> {
  item: BaseIO
  data: TerminalDataProps
}

export function EditTerminalsRow<TSystem extends SystemTypes>({ item, selected, data, systemType }: EditTerminalsRowProps<TSystem>) {
  const { state: termResState, dispatch: termResDispatch } = useTerminalResContext();
  const { updatedLocations } = termResState

  const selectedId = getSelectedId(systemType, selected);
  const terminalUpdate = termResState.terminalValues?.[item.terminal_id];

  const { call: getDevices, data: deviceInfoState } = useDeviceInfo(termResState.connection);

  useEffect(() => {
    getDevices({ fetchAmount: 500 }, termResState.connection);
  }, [termResState.connection, getDevices])

  const devices = useMemo(() => deviceInfoState[termResState.domain] && deviceInfoState[termResState.domain].data, [deviceInfoState, termResState.domain])

  const ioOptions = devices?.map((type) => ({
    label: type.name,
    id: type.device_id
  }));

  if (!data) return;
  return (
    <div key={`row_${selectedId}`} style={{ display: "grid", gridTemplateColumns: "60px 60px 100px 43px", gap: "10px" }}>

      {/* Text */}
      <div style={{ display: "flex", alignItems: "center", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
        <TooltipString contentString={item.text} duplicatedStrings overrides={{ contentstring: { ...fonts.fontWeight1 } }} />
      </div>

      {/* Port */}
      <NewInput
        key={`port_${selectedId}.${item.terminal_id}.${item.offset}`}
        placeholder={String(item.port)}
        onChange={(e) => {
          const port = item.boardDisabled ? undefined : Number(e) + (item.offset === 1 ? 100 : item.offset === 2 ? 200 : 0);
          const sensor_p = item.boardDisabled ? Number(e) + (item.offset === 1 ? 100 : 0) : undefined;

          const resultObject: { terminal_id: number, port?: number, sensor_p?: number } = {
            terminal_id: item.terminal_id,
          }
          if (port !== undefined) {
            resultObject.port = port;
          }

          if (sensor_p !== undefined) {
            resultObject.sensor_p = sensor_p;
          }

          termResDispatch({
            terminalValues: [resultObject]
          });
          termResDispatch({ updatedLocations: { ...updatedLocations, [selectedId]: Number(e) !== item.port } })
        }}
        fieldOverrides={{
          fieldStyle: NewFieldStyles.greyTertiary,
          fieldType: NewFieldTypes.tertiaryField,
          fieldWidth: "60px"
        }}
        valueOverrides={{
          defaultValue: Number(item.boardDisabled ? item.sensor_p : item.port) - (item.offset === 1 ? 100 : item.offset === 2 ? 200 : 0),
          valueType: "number",
          maxValueNumber: 99,
          minValueNumber: 1
        }}
      />

      {/* Board */}
      <NewSelect
        key={`board_${selectedId}_${item.board?.device_id}`}
        options={ioOptions}
        onChange={(selected) => {
          if (!selected?.id) return;

          termResDispatch({ terminalValues: [{ terminal_id: item.terminal_id, fk_devices: Number(selected.id) }] });
          termResDispatch({ updatedLocations: { ...updatedLocations, [selectedId]: Number(selected.id) !== (item.board?.device_id ?? 0) } });
        }}
        isDisabled={systemType === SystemTypes.freedaEsf_WalkThrough ? item.boardDisabled : false}
        fieldOverrides={{
          fieldStyle: NewFieldStyles.greyTertiary,
          fieldType: NewFieldTypes.tertiaryField,
          fieldWidth: "100px"
        }}
        valueOverrides={{
          defaultValue: ioOptions?.find(io => io.id === (terminalUpdate?.fk_devices ?? item.board?.device_id))
        }}
      />

      {/* HJÆÆÆÆÆLP FREDAG */}
      {/* Disabled */}
      <ToggleBox
        key={`on_${selectedId}.${item.terminal_id}`}
        toggleStyles={ToggleStyles.tableToggle}
        disabled={item.boardDisabled ? true : false}
        isChecked={!item.programmedDisabled}
        icon={glyphs.Start({ size: "17px" })}
        onChange={(e) => {
          const programmedArray = item.programmed.toString(2).padStart(8, "0").split("").reverse();
          programmedArray[0] = e ? "0" : "1";
          const configProgrammed = parseInt(programmedArray.reverse().join(""), 2);

          termResDispatch({ terminalValues: [{ terminal_id: item.terminal_id, configProgrammed: configProgrammed }] });
          termResDispatch({ updatedLocations: { ...updatedLocations, [selectedId]: configProgrammed !== item.programmed } });

          // if (systemType !== SystemTypes.freedaLf && item.offset === 1) {
          //   console.log(systemType)
          //   const motor = data.terminals.find(t => !t.offset);
          //   if (!motor) return;

          //   const motorProgrammed = motor.programmed;
          //   const motorProgrammedArray = motorProgrammed.toString(2).padStart(8, "0").split("").reverse();

          //   if (Boolean(Number(motorProgrammedArray[2])) === !e) return;

          //   motorProgrammedArray[2] = e ? "0" : "1";
          //   const newMotorProgrammed = parseInt(motorProgrammedArray.reverse().join(""), 2);

          //   termResDispatch({ terminalValues: [{ terminal_id: item.terminal_id, configProgrammed: newMotorProgrammed }] });
          //   termResDispatch({ updatedLocations: { ...updatedLocations, [motor.terminal_id]: newMotorProgrammed !== motor.programmed } });
          // }
        }}
      />
    </div>
  )
}
